export const environment = {};

export const apiQaroniEnvironment = {
  URLBase: 'https://api.dev.secure-txn.com/mgram',
};
